// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1nwQO","item":"PaymentsMobile_item__22Vws","label":"PaymentsMobile_label__2p-eL","amount":"PaymentsMobile_amount__3Wii4"};